export enum UserStateEnum {
  NotAuthenticated = "NotAuthenticated",
  Authenticated = "Authenticated",
  NoRoles = "NoRoles",
  FailedToGetRoles = "FailedToGetRoles",
  NotConfirmed = "NotConfirmed",
}
